// React
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// Libraries
import PropTypes from "prop-types";
import { isEmpty } from "lodash";

// Redux
import { useSelector } from "react-redux";

const PublicRoute = ({ isLoggedIn = false, hasCompany = false }) => {
	const defaultMenu = useSelector((state) => {
		return state.user.defaultMenu;
	});
	if (isLoggedIn) {
		if (hasCompany) {
			return <Navigate to={isEmpty(defaultMenu) ? "/monitor" : defaultMenu.path} replace />;
		}
		return <Navigate to="/chooseCompany" replace />;
	}
	return <Outlet />;
};

PublicRoute.propTypes = {
	isLoggedIn: PropTypes.bool,
	hasCompany: PropTypes.bool,
};

export default PublicRoute;
